import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { siteConfig } from '../../../config/site';

const QuoteForm = () => {
  const isDesentupimentosSite = siteConfig.domain === 'alphadesentupimentos.pt';
  const isEletricaSite = siteConfig.domain === 'alphaeletrica.pt' || siteConfig.domain === 'alphaeletric.pt';
  const isEletrodomesticosSite = siteConfig.domain === 'alphaservices.pt';
  const isPortoSite = siteConfig.domain === 'alphacanalizacoesporto.pt';
  const isCleanSite = siteConfig.domain === 'alphaclean.pt';
  const isClimatizacaoSite = siteConfig.domain === 'alphaclimatizacao.pt';
  // Na climatização o email é opcional: nome, telefone e zona chegam para orçamentar
  const emailObrigatorio = !isClimatizacaoSite;
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nome: '',
    telefone: '',
    email: '',
    rua: '',
    localidade: '',
    distrito: '',
    codigoPostal: '',
    observacoes: '',
    tipoAvaria: '',
    rgpdConsent: false
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.rgpdConsent) {
      alert('Por favor, aceite os termos de privacidade para continuar.');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      let response;

      if (isCleanSite) {
        // alphaclean.pt: entrega directa por FormSubmit, sem passar pela
        // conta partilhada do Web3Forms.
        response = await fetch('https://formsubmit.co/ajax/alphaservices.pt@gmail.com', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            _subject: `NOVO ORÇAMENTO [${siteConfig.name}]: ${formData.tipoAvaria}`,
            _template: 'table',
            Nome: formData.nome,
            Telefone: formData.telefone,
            Email: formData.email || 'N/A',
            Rua: formData.rua || 'N/A',
            Localidade: formData.localidade,
            Distrito: formData.distrito || 'N/A',
            Codigo_Postal: formData.codigoPostal || 'N/A',
            Servico: formData.tipoAvaria,
            Observacoes: formData.observacoes || 'Nenhuma'
          })
        });
      } else if (isEletricaSite) {
        // Envia para FormSubmit no site da Elétrica
        response = await fetch('https://formsubmit.co/ajax/Alphaeletricapt@gmail.com', {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            _subject: `NOVO ORÇAMENTO [${siteConfig.name}]: ${formData.tipoAvaria}`,
            _template: 'table',
            Nome: formData.nome,
            Telefone: formData.telefone,
            Email: formData.email || 'N/A',
            Rua: formData.rua || 'N/A',
            Localidade: formData.localidade,
            Distrito: formData.distrito || 'N/A',
            Codigo_Postal: formData.codigoPostal || 'N/A',
            Servico: formData.tipoAvaria,
            Observacoes: formData.observacoes || 'Nenhuma'
          })
        });
      } else {
        // Envia para Web3Forms nos outros sites
        response = await fetch('https://api.web3forms.com/submit', {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            access_key: siteConfig.web3formsKey || 'da198dbc-68bf-4341-b543-3c734419e8f0',
            subject: `NOVO ORÇAMENTO [${siteConfig.name}]: ${formData.tipoAvaria}`,
            from_name: siteConfig.name,
            Nome: formData.nome,
            Telefone: formData.telefone,
            Email: formData.email || 'N/A',
            Rua: formData.rua || 'N/A',
            Localidade: formData.localidade,
            Distrito: formData.distrito || 'N/A',
            Codigo_Postal: formData.codigoPostal || 'N/A',
            Servico: formData.tipoAvaria,
            Observacoes: formData.observacoes || 'Nenhuma'
          })
        });
      }

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nome: '',
          telefone: '',
          email: '',
          rua: '',
          localidade: '',
          distrito: '',
          codigoPostal: '',
          observacoes: '',
          tipoAvaria: '',
          rgpdConsent: false
        });
        // Registra a conversão no Google Ads com Enhanced Conversions.
        // No alphaclean.pt a conversão OBRIGADO é disparada na página
        // /obrigado, para onde redirecionamos a seguir — dispará-la aqui
        // também contava duas vezes o mesmo lead.
        // Na climatização acontece o mesmo: aqui só guardamos os dados para as
        // Enhanced Conversions e a conversão é contada uma vez em /obrigado.
        if (isClimatizacaoSite && typeof window !== 'undefined' && window.gtag) {
          window.gtag('set', 'user_data', {
            ...(formData.email ? { email: formData.email } : {}),
            phone_number: formData.telefone
          });
        } else if (!isCleanSite && typeof window !== 'undefined' && window.gtag_report_conversion) {
          window.gtag_report_conversion(null, {
            email: formData.email,
            phone: formData.telefone
          });
        }

        // Redireciona para página de obrigado após 1 segundo
        setTimeout(() => {
          navigate('/obrigado/');
        }, 1000);
      } else {
        const errorData = await response.json().catch(() => ({}));
        console.error('Erro ao enviar email:', errorData);
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value, type } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? (e.target as HTMLInputElement).checked : value
    }));
  };

  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-900 mb-2">Orçamento Gratuito</h2>
      <p className="text-gray-600 mb-6">Preencha o formulário e receba uma resposta rápida</p>

      <form id="orcamento-form" data-readdy-form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="nome" className="block text-sm font-medium text-gray-700 mb-1">
            Nome Completo *
          </label>
          <input
            type="text"
            id="nome"
            name="nome"
            value={formData.nome}
            onChange={handleChange}
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
            placeholder="O seu nome"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label htmlFor="telefone" className="block text-sm font-medium text-gray-700 mb-1">
              Telefone *
            </label>
            <input
              type="tel"
              id="telefone"
              name="telefone"
              value={formData.telefone}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
              placeholder={siteConfig.phoneDisplay}
            />
          </div>

          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
              Email {emailObrigatorio ? '*' : <span className="text-gray-400 font-normal">(opcional)</span>}
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required={emailObrigatorio}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
              placeholder="seuemail@exemplo.com"
            />
          </div>
        </div>

        {isEletrodomesticosSite ? (
          <div className="space-y-4 pt-2 border-t border-gray-100">
            <div>
              <label htmlFor="rua" className="block text-sm font-medium text-gray-700 mb-1">
                Rua / Morada *
              </label>
              <input
                type="text"
                id="rua"
                name="rua"
                value={formData.rua}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                placeholder="Ex: Rua Direita, 123"
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label htmlFor="localidade" className="block text-sm font-medium text-gray-700 mb-1">
                  Localidade *
                </label>
                <input
                  type="text"
                  id="localidade"
                  name="localidade"
                  value={formData.localidade}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="Vila Nova de Gaia"
                />
              </div>
              <div>
                <label htmlFor="distrito" className="block text-sm font-medium text-gray-700 mb-1">
                  Distrito *
                </label>
                <input
                  type="text"
                  id="distrito"
                  name="distrito"
                  value={formData.distrito}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="Porto"
                />
              </div>
            </div>
            <div>
              <label htmlFor="codigoPostal" className="block text-sm font-medium text-gray-700 mb-1">
                Código Postal *
              </label>
              <input
                type="text"
                id="codigoPostal"
                name="codigoPostal"
                value={formData.codigoPostal}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                placeholder="0000-000"
              />
            </div>
            <div>
              <label htmlFor="observacoes" className="block text-sm font-medium text-gray-700 mb-1">
                Observações
              </label>
              <textarea
                id="observacoes"
                name="observacoes"
                value={formData.observacoes}
                onChange={handleChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm h-24 resize-none"
                placeholder="Ex: Possui pedra para cortar, furos na parede, etc..."
              />
              <p className="text-[10px] text-amber-700 mt-1 bg-amber-50 p-2 rounded">
                <i className="ri-error-warning-line mr-1"></i>
                O local deve estar adequado para instalação. Cortes em pedra ou falta de ligações próximas acarretam custos extras.
              </p>
            </div>
          </div>
        ) : (
          <div>
            <label htmlFor="localidade" className="block text-sm font-medium text-gray-700 mb-1">
              Localidade *
            </label>
            <input
              type="text"
              id="localidade"
              name="localidade"
              value={formData.localidade}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
              placeholder={siteConfig.address.city === 'Porto' ? 'Porto, Vila Nova de Gaia, Matosinhos...' : 'Lisboa, Almada, Oeiras...'}
            />
          </div>
        )}

        <div>
          <label htmlFor="tipoAvaria" className="block text-sm font-medium text-gray-700 mb-1">
            Tipo de Serviço *
          </label>
          <select
            id="tipoAvaria"
            name="tipoAvaria"
            value={formData.tipoAvaria}
            onChange={handleChange}
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm pr-8"
          >
            <option value="">Selecione o serviço</option>
            {siteConfig.domain === 'alphaclean.pt' ? (
              <>
                <option value="Limpeza de Condomínios">Limpeza de Condomínios</option>
                <option value="Limpeza Pós-Obra">Limpeza Pós-Obra</option>
                <option value="Limpeza de Escritórios">Limpeza de Escritórios</option>
                <option value="Limpeza Residencial">Limpeza Residencial</option>
                <option value="Limpeza de Alojamento Local">Limpeza de Alojamento Local</option>
                <option value="Limpeza de Restaurantes">Limpeza de Restaurantes</option>
                <option value="Limpeza de Lojas e Comércio">Limpeza de Lojas e Comércio</option>
                <option value="Outro">Outro</option>
              </>
            ) : siteConfig.domain === 'alphaclimatizacao.pt' ? (
              <>
                <option value="Manutenção de Ar Condicionado">Manutenção de Ar Condicionado</option>
                <option value="Instalação de Ar Condicionado">Instalação de Ar Condicionado</option>
                <option value="Venda de Equipamento">Venda de Equipamento</option>
                <option value="Pré-Instalação para Obra">Pré-Instalação para Obra</option>
                <option value="Peças de Reposição">Peças de Reposição</option>
                <option value="Reparação / Avaria">Reparação / Avaria</option>
                <option value="Contrato de Manutenção">Contrato de Manutenção</option>
                <option value="Outro">Outro</option>
              </>
            ) : isDesentupimentosSite ? (
              <>
                <option value="Desentupimento de Esgotos">Desentupimento de Esgotos</option>
                <option value="Desentupimento de Sanitas">Desentupimento de Sanitas</option>
                <option value="Desentupimento de Lavatórios e Pias">Desentupimento de Lavatórios e Pias</option>
                <option value="Desentupimento de Colunas Prediais">Desentupimento de Colunas Prediais</option>
                <option value="Desentupimento com Hidrojato">Desentupimento com Hidrojato</option>
                <option value="Vídeo Inspeção de Tubulações">Vídeo Inspeção de Tubulações</option>
                <option value="Outro">Outro</option>
              </>
            ) : isEletricaSite ? (
              <>
                <option value="Instalação Elétrica">Instalação Elétrica</option>
                <option value="Reparação de Avarias">Reparação de Avarias</option>
                <option value="Quadros Elétricos">Quadros Elétricos</option>
                <option value="Iluminação LED">Iluminação LED</option>
                <option value="Ar Condicionado">Ar Condicionado</option>
                <option value="Sistema AVAC">Sistema AVAC</option>
                <option value="Vídeo Porteiros">Vídeo Porteiros</option>
                <option value="Portões Automáticos">Portões Automáticos</option>
                <option value="Fechaduras Inteligentes">Fechaduras Inteligentes</option>
                <option value="Controlo de Acessos">Controlo de Acessos</option>
                <option value="Certificações">Certificações</option>
                <option value="Manutenção Elétrica">Manutenção Elétrica</option>
                <option value="Manutenção de Sistemas">Manutenção de Sistemas</option>
                <option value="Outro">Outro</option>
              </>
              ) : isEletrodomesticosSite ? (
                <>
                  <option value="Instalação de Placa Elétrica">Instalação de Placa Elétrica</option>
                  <option value="Instalação de Forno Elétrico">Instalação de Forno Elétrico</option>
                  <option value="Instalação de Fogão Elétrico">Instalação de Fogão Elétrico</option>
                  <option value="Instalação de Microondas">Instalação de Microondas</option>
                  <option value="Instalação de Máquina de Lavar">Instalação de Máquina de Lavar</option>
                  <option value="Instalação de Frigorífico">Instalação de Frigorífico</option>
                  <option value="Instalação de Termoacumulador">Instalação de Termoacumulador</option>
                  <option value="Outro">Outro</option>
                </>
              ) : (
                <>
                  <option value="Detecção e Reparação de Fugas de Água">Detecção e Reparação de Fugas de Água</option>
                  <option value="Reparação de Canalização">Reparação de Canalização</option>
                  <option value="Instalação de Canalização">Instalação de Canalização</option>
                  <option value="Manutenção Preventiva">Manutenção Preventiva</option>
                  <option value="Remodelação de Casas de Banho">Remodelação de Casas de Banho</option>
                  {isPortoSite && (
                    <option value="Pinturas e Pladur">Pinturas e Pladur</option>
                  )}
                  <option value="Outro">Outro</option>
                </>
              )}
          </select>
        </div>

        <div className="flex items-start gap-3">
          <input
            type="checkbox"
            id="rgpdConsent"
            name="rgpdConsent"
            checked={formData.rgpdConsent}
            onChange={handleChange}
            required
            className="mt-1 w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
          />
          <label htmlFor="rgpdConsent" className="text-sm text-gray-600">
            Concordo com o armazenamento dos meus dados para ser contactado pela {siteConfig.name}.
            <span className="text-xs block mt-1 text-gray-500">
              Cumprimos RGPD. Dados usados apenas para resposta ao seu pedido.
            </span>
          </label>
        </div>

        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-4 px-6 rounded-lg transition-colors duration-200 disabled:opacity-50 whitespace-nowrap"
        >
          {isSubmitting ? 'A enviar...' : 'Pedir Orçamento Gratuito'}
        </button>

        {submitStatus === 'success' && (
          <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
            <p className="text-green-800 text-sm">
              ✅ Pedido enviado com sucesso! Entraremos em contacto brevemente.
            </p>
          </div>
        )}

        {submitStatus === 'error' && (
          <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-red-800 text-sm">
              ❌ Erro ao enviar. Tente novamente ou ligue {siteConfig.phoneDisplay}.
            </p>
          </div>
        )}
      </form>
    </div>
  );
};

export default QuoteForm;
